export default __webpack_public_path__ + "/image/pepr2ds_cover_8439359.png";